import { forwardRef, type HTMLAttributes, type PropsWithChildren } from 'react';
import { H1 } from '@components/Typography/Typography';
import cn from 'classnames';

import css from './styles.module.scss';

interface ResourctTitleProps
  extends PropsWithChildren,
    HTMLAttributes<HTMLDivElement> {
  className?: string;
  variant?: 'gradient' | 'plain';
}

const ResourceTitle = forwardRef<HTMLDivElement, ResourctTitleProps>(
  ({ children, variant = 'gradient', ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={cn('flex items-center gap-4 w-full', props.className)}
      >
        <span className={cn(css.line, variant === 'plain' && css.plain)}></span>
        <H1 weight="black" className="text-white">
          {children}
        </H1>
        <span className={cn(css.line, variant === 'plain' && css.plain)}></span>
      </div>
    );
  },
);

export { ResourceTitle };
